export default "__VITE_ASSET__B1kmG6bC__"